import {
    Container,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    Box,
    Typography,
    CircularProgress
} from '@mui/material'
import { Body } from 'src/components/MUIBased/Blocks/Body'
import { ContainerTitle } from 'src/components/MUIBased/Blocks/ContainerTitle'
import NavBarHeading from 'src/components/MUIBased/NavBarHeading'
import { StandardPageHeader } from 'src/components/MUIBased/pageHeaders'
import { useOpenLoopSubscriptionProduct } from './hooks/useOpenLoopSubscriptionProduct'
import { useMWLSubscriptionChargeItem } from './hooks/useMWLSubscriptionChargeItem'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { EmailConsistencyReminder } from 'src/pages/MUIBased/CustomizedWeightManagementSubscription/EmailConsistencyReminder'
import { MedicationEducation } from 'src/pages/MUIBased/CustomizedWeightManagementSubscription/MedicationEducation'

const Payment = () => {
    const navigate = useNavigate()

    const { isLoading: isLoadingProducts, subscriptionProducts } =
        useOpenLoopSubscriptionProduct()
    const { isLoading: isLoadingChargeItem, chargeItem } =
        useMWLSubscriptionChargeItem()
    const [selectedProduct, setSelectedProduct] = useState<string>('')

    const handleProductSelect = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSelectedProduct(event.target.value)
    }

    const handleSubmit = () => {
        const selectedProductData = subscriptionProducts?.find(
            product => product.stripeProductId === selectedProduct
        )
        if (selectedProductData?.stripeCheckoutUrl) {
            window.location.href = selectedProductData.stripeCheckoutUrl
        }
    }

    const isLoading = isLoadingProducts || isLoadingChargeItem

    // Handle navigation if we have a charge item
    if (chargeItem) {
        navigate('/customized-weight-management-subscription/booking')
        return null
    }

    return (
        <Body>
            <StandardPageHeader />
            <NavBarHeading href="/" showBackButton={false} />
            <Container>
                {isLoading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '200px'
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <ContainerTitle
                            title="Choose your medication preference"
                            description="Please pick your preferred medication and dosing type as discussed with your provider"
                        />

                        <Box sx={{ mb: 2 }}>
                            <MedicationEducation />

                            <FormControl component="fieldset">
                                <RadioGroup
                                    value={selectedProduct}
                                    onChange={handleProductSelect}
                                >
                                    {subscriptionProducts?.map(product => (
                                        <FormControlLabel
                                            key={product.stripeProductId}
                                            value={product.stripeProductId}
                                            control={<Radio />}
                                            label={product.productDisplayName}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </Box>

                        <EmailConsistencyReminder />

                        <Button
                            variant="contained"
                            size="large"
                            fullWidth
                            disabled={!selectedProduct}
                            onClick={handleSubmit}
                        >
                            Continue to Payment
                        </Button>
                    </>
                )}
            </Container>
        </Body>
    )
}

export default Payment
